import * as React from 'react';
import jamesAvatar from '../images/news/avatar-james.jpg';
import styled from 'styled-components';

const Author = styled.span`
	color: grey;
	display: block;
	margin-bottom: 1rem;

	& img {
		width: 24px;
		height: 24px;
		border-radius: 12px;
		margin-right: 0.5em;
	}
`;

const AuthorJames = () => (
	<Author><img src={jamesAvatar} alt='Author: James Bowles' />James Bowles</Author>
);

export default AuthorJames;
